import { useOutletContext } from "react-router";

import { Divider, Stack } from "@mui/material";
import { ClientContent } from "@shared";

import { ClientDetailResponse } from "@/api";
import { ClientCurrentAgreementOverview } from "@/pages/clients/client/components/tabs/overview-tab/components/current-agreement-overview/ClientCurrentAgreementOverview";
import { useClientOverview } from "@/pages/clients/client/components/tabs/overview-tab/hooks/useClientOverview";

import { useClientPersonalDataEdit } from "./hooks/useClientPersonalData";
import { PersonalDataAddressSection } from "./sections/address/PersonalDataAddressSection";
import { PersonalDataBackgroundSection } from "./sections/background/PersonalDataBackgroundSection";
import { PersonalDataCommentSection } from "./sections/comment/PersonalDataCommentSection";
import { PersonalDataEmploymentSection } from "./sections/employment/PersonalDataEmploymentSection";
import { PersonalDataIdentitySection } from "./sections/identity/PersonalDataIdentitySection";
import { PersonalDataNameSection } from "./sections/name/PersonalDataNameSection";

export function PersonalDataView() {
  const client = useOutletContext<ClientDetailResponse>();

  const { lastAgreement } = useClientOverview(client);
  const { formik, dropdownOptions, personalData } = useClientPersonalDataEdit(client.clientId);

  return (
    <ClientContent formik={formik}>
      <ClientCurrentAgreementOverview lastAgreement={lastAgreement} defaultExpanded={false} />
      <Stack bgcolor={"white"} flex={1} p={2} gap={4} divider={<Divider />}>
        <PersonalDataCommentSection formik={formik} />
        <PersonalDataNameSection formik={formik} dropdownOptions={dropdownOptions} />
        <PersonalDataIdentitySection formik={formik} />
        <PersonalDataAddressSection formik={formik} />
        <PersonalDataEmploymentSection formik={formik} clientId={client.clientId} personalData={personalData} />
        <PersonalDataBackgroundSection formik={formik} dropdownOptions={dropdownOptions} />
      </Stack>
    </ClientContent>
  );
}
